import type { IAugmentedJQuery, IController, IScope } from "angular";

import { EquipmentClassFunctions } from "App/Modules/Models";

export default class SvgIconDirectiveController implements IController {
    public static $inject = ["$scope", "$element"];

    public icon: string;

    public iconGlyph: string = null;

    constructor(private $scope: IScope, private $element: IAugmentedJQuery) {}

    public $onInit() {
        this.$scope.$watch("$ctrl.icon", () => this.updateIcon());
    }

    private updateIcon() {
        this.iconGlyph = EquipmentClassFunctions.IconToUnicodeCharacter(this.icon);
    }
}
